import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Chromeless layout for stand-alone states (errors, unauthorized, forbidden,
 * not-found): NO header, NO sidebar, NO breadcrumb, NO footer — just a
 * brand mark and the page content, centered. See design proposal:
 * "Les pages d'erreur et la page d'accès non autorisé doivent contenir
 * aucun menu et les contenus doivent être centrés."
 */
export function BareLayout() {
  const { t } = useTranslation();
  return (
    <div className="nbs-bare">
      <Link to="/" className="nbs-bare__brand" aria-label={t("app.name")}>
        <span className="nbs-bare__mark" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 3c3.5 2 6 5 6 9 0 3.3-2.7 6-6 6s-6-2.7-6-6c0-4 2.5-7 6-9Z"
              fill="#bfe6cd"
            />
            <path
              d="M12 21V9m0 4 3-2m-3 5-2.6-1.7"
              stroke="#0f3d28"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
          </svg>
        </span>
        {t("app.name")}
      </Link>
      <Outlet />
    </div>
  );
}
